module.exports = kolibriCoreAppGlobal.coreVue.components.UiAlert;